const url = (id) => `${ process.env.VUE_APP_API_URL }/images/image/${ id }`;

export default {
    url,
};
